import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-start" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      target: "_blank",
      rel: "nofollow noopener",
      href: _ctx.RUSSIAN_SOFTWARE_REGISTRY_HREF
    }, [
      _createVNode(_component_q_img, {
        src: "/images/logo-reestr-digital.svg",
        width: _ctx.width,
        alt: "Реестр отечественного ПО"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.RUSSIAN_SOFTWARE_REGISTRY_DESCRIPTION), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["width"])
    ], 8, _hoisted_2)
  ]))
}